export const normalizeCaseStudyTags = (tags: string[] | undefined): string[] => {
  if (!tags?.length) {
    return []
  }

  const unique = new Set<string>()
  for (const raw of tags) {
    const tag = raw.trim()
    if (!tag) {
      continue
    }
    unique.add(tag)
  }
  return Array.from(unique)
}

type ResolveOptions = {
  primary?: string[]
  fallback?: string[]
  max?: number
  reverse?: boolean
}

export const resolveSyncedCaseStudyTags = ({
  primary,
  fallback,
  max = 4,
  reverse = true,
}: ResolveOptions): string[] => {
  const source = normalizeCaseStudyTags(primary).length
    ? normalizeCaseStudyTags(primary)
    : normalizeCaseStudyTags(fallback)
  const ordered = reverse ? [...source].reverse() : source
  return ordered.slice(0, Math.max(0, max))
}
